<template>
<div class="label-affiliate">
  <el-table :data="affiliateLabels.data" class="w100" stripe>
    <el-table-column label="First name" prop="first_name" sortable></el-table-column>
    <el-table-column label="Last name" prop="surname" sortable></el-table-column>
    <el-table-column label="Artist name" prop="name" sortable></el-table-column>
    <el-table-column label="Affiliate code" prop="code" sortable></el-table-column>
    <el-table-column label="Affiliate URL">
      <template slot-scope="props">
        {{ frontAppUrl }}/aff/{{ props.row.code }}
      </template>
    </el-table-column>
    <el-table-column label="Affiliates" align="right">
      <template slot-scope="props">
        <el-tooltip content="Update affiliate model" placement="top">
          <el-button type="warning" class="mr5" circle size="small" icon="el-icon-edit"
                     @click="readAffiliateModel(props.row.user_id)"></el-button>
        </el-tooltip>
        <el-tooltip content="Show affiliates" placement="top">
          <el-popover placement="right" width="600" trigger="click">
            <el-table :data="affiliate_customers" max-height="350" v-loading="affiliateCustomerLoading">
              <el-table-column prop="first_name" label="First name"></el-table-column>
              <el-table-column prop="surname" label="Last name"></el-table-column>
              <el-table-column prop="email" label="E-mail"></el-table-column>
            </el-table>
            <el-button type="success" circle size="small" icon="el-icon-user" slot="reference"
                       @click="showAffiliates(props.row)"></el-button>
          </el-popover>
        </el-tooltip>
        <el-tooltip class="ml10" content="Export CSV" placement="top">
          <el-button type="primary" circle size="small" icon="el-icon-document"
                     @click="exportCSV({ user: props.row, type: 'label' })"></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      class="float-right" background @size-change="sizeChange" @current-change="currentChange"
      :current-page.sync="affiliateLabels.current_page" :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="labelPageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="affiliateLabels.total"
  ></el-pagination>
</div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  computed: {
    ...mapState('affiliate', [
        'affiliateLabels', 'labelPage', 'labelPageSize', 'affiliate_customers',
        'affiliateCustomerLoading'
    ]),

    frontAppUrl() {
      return process.env.VUE_APP_FRONT_URL.slice(0, -1)
    }
  },

  methods: {
    ...mapMutations('affiliate', ['setAffiliateLabels', 'setLabelPageSize', 'setLabelPage']),
    ...mapActions('affiliate', ['getAffiliatePartners', 'readAffiliateCustomers', 'exportCSV', 'readAffiliateModel']),

    showAffiliates(row) {
      this.readAffiliateCustomers({ user: row.user_id, type: 'label' })
    },

    sizeChange(pageSize) {
      this.setLabelPageSize(pageSize)
      this.getAffiliatePartners('label')
    },

    currentChange(page) {
      this.setLabelPage(page)
      this.getAffiliatePartners('label')
    }
  },

  created() {
    this.getAffiliatePartners('label')
  }
}
</script>